import React from 'react';
import { Text } from '@chakra-ui/react';
import { ConfirmDialog } from 'src/components/molecules/ConfirmDialog';
import { ManagedUser } from 'src/api/users';

type DeleteUserDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  user: ManagedUser | null;
  isLoading: boolean;
};

export const DeleteUserDialog: React.FC<DeleteUserDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  user,
  isLoading,
}) => {
  if (!user) return null;

  return (
    <ConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      headerText="Remove User"
      bodyText={
        <>
          <Text>Are you sure you want to remove this user from your team?</Text>
          <Text mt={2} color="content.muted" fontSize="sm">
            This action cannot be undone.
          </Text>
        </>
      }
      confirmText="Remove User"
      isLoading={isLoading}
    />
  );
};
